import { render, staticRenderFns } from "./ExtractInstanceFromRawDataDetailComponent.vue?vue&type=template&id=124342df&scoped=true&"
import script from "./ExtractInstanceFromRawDataDetailComponent.vue?vue&type=script&lang=js&"
export * from "./ExtractInstanceFromRawDataDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExtractInstanceFromRawDataDetailComponent.vue?vue&type=style&index=0&id=124342df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124342df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
